module.exports = __webpack_public_path__ + "img/header/fam-watermark-fallback.svg";